import React, { useEffect } from 'react';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale } from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

const LineChart = ({ data }) => {debugger;
    const chartData = {
        labels: data.map(entry => entry.date), // Get the dates for the x-axis
        datasets: [
            {
                label: 'Forms Submitted (Past 7 Days)',
                backgroundColor: 'rgba(60,141,188,0.9)',
                borderColor: 'rgba(60,141,188,0.8)',
                data: data.map(entry => entry.count), // Get the counts for the y-axis
                fill: false,
                tension: 0.1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                grid: {
                    display: false,
                },
            },
        },
    };


    return (
        <div className="card card-info">
            <div className="card-header">
                <h3 className="card-title">Forms Submitted in last 7 Days:</h3>
                <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus"></i>
                    </button>
                    <button type="button" className="btn btn-tool" data-card-widget="remove">
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className="chart" style={{ position: 'relative', height: '250px' }}>
                    <Line data={chartData} options={options} />
                </div>
            </div>
        </div>
    );
};

export default LineChart;
